import React from 'react';
import PropTypes from 'prop-types';

import PhoneInput from 'react-phone-number-input';

import 'react-phone-number-input/style.css';

class PhoneNumberInput extends React.Component {
  static propTypes = {
    number: PropTypes.any,
    fieldName: PropTypes.string.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func.isRequired,
    disableAutosave: PropTypes.bool,
  };

  static defaultProps = {
    number: null,
    disableAutosave: true,
  };

  constructor(props) {
    super(props);

    const phone = this.props.number;

    this.state = {
      phone,
    };
  }

  handleChange = (phone) => {
    // This ensures that the picked date is set as noon of the client's timezone.

    this.setState({ phone }, () => {
      this.props.setFieldValue(this.props.fieldName, phone);
    });
  };

  render() {
    const inputValue = this.state.phone;

    return (
      <>
        <PhoneInput
          placeholder="Enter phone number"
          value={inputValue}
          onChange={this.handleChange}
        />
      </>
    );
  }
}

export default PhoneNumberInput;
